var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0411\\u0435\\u043B\\u044B\\u0435",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.8,67.9c-12.9-15.7-40.2-34-69.9-34c-29.9,0-57.1,18.4-69.9,34c-1.3,1.5-1.3,3.8,0,5.3c13.2,16.1,40.5,34,69.9,34 c30.4,0,57.6-19,69.9-34C142,71.6,142,69.4,140.8,67.9z M100.6,70.5c0,16.4-13.4,29.8-29.8,29.8c-16.4,0-29.8-13.4-29.8-29.8 c0-16.4,13.4-29.8,29.8-29.8C87.3,40.8,100.6,54.1,100.6,70.5L100.6,70.5z M9.8,70.5c4.7-4.9,16-15.4,31.9-22.2 c-10,13.1-10,31.2,0,44.3C29.6,87.6,18.4,79.5,9.8,70.5z M100,92.7c10-13.1,10-31.2,0-44.3c12.1,5.1,23.3,13.2,31.9,22.1 C127.2,75.4,115.9,85.9,100,92.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7,70.5c0,7.8,6.4,14.2,14.2,14.2c7.8,0,14.2-6.4,14.2-14.2s-6.4-14.2-14.2-14.2C63.1,56.4,56.7,62.7,56.7,70.5z  M78,70.5c0,3.9-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1C74.8,63.4,78,66.6,78,70.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9,18.3c2,0,3.6-1.9,3.6-4.2V4.4c0-2.3-1.6-4.2-3.6-4.2c-2,0-3.6,1.9-3.6,4.2v9.7C67.3,16.5,68.9,18.3,70.9,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,22.2c1.7-1,2.2-3.4,1-5.4l-4.8-8.4c-1.1-2-3.5-2.8-5.2-1.9c-1.7,1-2.2,3.4-1,5.4l4.8,8.4 C41.6,22.3,43.9,23.2,45.6,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,20.3l4.8-8.4c1.1-2,0.7-4.4-1-5.4c-1.7-1-4-0.1-5.2,1.9l-4.8,8.4c-1.1,2-0.7,4.4,1,5.4 C97.9,23.2,100.2,22.3,101.3,20.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.3,127.7v9.7c0,2.3,1.6,4.2,3.6,4.2c2,0,3.6-1.9,3.6-4.2v-9.7c0-2.3-1.6-4.2-3.6-4.2C68.9,123.5,67.3,125.4,67.3,127.7z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,121.5l-4.8,8.4c-1.1,2-0.7,4.4,1,5.4c1.7,1,4,0.1,5.2-1.9l4.8-8.4c1.1-2,0.7-4.4-1-5.4 C43.9,118.7,41.6,119.5,40.5,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2,119.6c-1.7,1-2.2,3.4-1,5.4l4.8,8.4c1.1,2,3.5,2.8,5.2,1.9c1.7-1,2.2-3.4,1-5.4l-4.8-8.4 C100.2,119.5,97.9,118.7,96.2,119.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.712eea6b00a0dd447874b84f469c70a7.svg";
export { ForwardRef as ReactComponent };